import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailVerificationRoutingModule } from './email-verification-routing.module';
import { EmailVerficationComponent } from './components/email-verfication/email-verfication.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
  declarations: [
    EmailVerficationComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    TranslateModule,
    MatMenuModule,
    EmailVerificationRoutingModule
  ]
})
export class EmailVerificationModule { }
